/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, October 15th 2021, 10:46:35 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

// Django end points should end with forward slash since POST requests cannot be redirected and maintain the
// same data body. https://docs.djangoproject.com/en/2.2/_modules/django/middleware/common/

export const enum APISERVICEPATHS {
  /** Auth */
  sessionAuth = "/auth/session/",
  tokenAuth = "/auth/jwt/login/",
  adminSignup = "/auth/admin-signup/",
  adminCompleteRegistration = "/auth/admin-complete-registration/",
  adminGoogleLogin = "/auth/admin-google-login/",
  adminGoogleSignup = "/auth/admin-google-sign-up/",
  workerAcceptInvitation = "/workers/invitations/accept/",
  resetPassword = "/auth/dj-rest-auth/password/reset/",
  resetPasswordConfirmation = "/auth/dj-rest-auth/password/reset/confirm/",
  sessionPing = "/session-security/ping/",
  permissions = "/auth/permissions/",
  otpDeviceTypes = "/auth/otp-device-types/",

  /** Logged in User */
  userDetails = "/logged-in-user-details/",
  registrationProfiles = "/registration-profiles/",

  /** Organizations */
  publicOrganizations = "/public/organizations/", // Endpoint to be used by any user to only get general organization info e.g. for users accepting invitations.
  workerOrganizations = "/authenticated-worker/organizations/", // Endpoint with more details organization info to be used by authenticated users who belong to that organization
  departments = "/departments/",
  organizationToggleActivation = "/organization/toggle-activation/",

  /** Workers */
  workers = "/workers/",
  workProfiles = "/workers/work-profiles/",
  workerInvitations = "/workers/invitations/",
  changeWorkerType = "/workers/change-worker-type/",
  removeWorker = "/workers/remove-worker/",

  /** Teams */
  teams = "/teams/",

  /** Common */
  sectors = "/sectors/",
  countries = "/countries/",
  currencies = "/currencies/",
  contextTags = "/context-tags/",
  contentTags = "/content-tags/",

  /** Portals */
  portals = "/portals/",
  mailServers = "/mail-servers/",
  testMailServer = "/test-mail-server/",
  mainSiteDetails = "/onestop-site/",
  websiteMenus = "/website-menus/",
  websitePages = "/website-pages/",
  portalMenuKeys = "/portal-menu-keys/",

  /** PreBuilt Services */
  prebuiltServices = "/prebuilt-services/",
  prebuiltServiceCategories = "/prebuilt-service-categories/",

  /** Workflow Builder */
  processDefinitions = "/process-definitions/",
  processTemplateCategories = "/process-template-categories/",
  taskDefinitions = "/task-definitions/",
  taskDefinitionsReorder = "/task-definitions/reorder/",
  activationConditions = "/activation-conditions/",
  nextActivations = "/next-activations/",
  processStages = "/process-stages/",
  notificationTemplates = "/notification-templates/",
  userTaskTypes = "/user-task-types/",

  /** Form Builder */
  forms = "/forms/",
  formFields = "/fields/",
  formFieldsReorder = "/fields/reorder/",
  fieldChoiceOption = "/choice-options/",
  fieldChoiceOptionGroup = "/choice-option-groups/",
  fieldValidators = "/field-validators/",
  fieldDependencies = "/field-dependencies/",
  fieldTypes = "/field-types/",

  /** Documents */
  designLayouts = "/design-layouts/",
  documentTemplates = "/document-templates/",

  /** Digital Signatures */
  digitalSignatureMethods = "/digital-signature-methods/",
  digitalSigningSettings = "/digital-signing-settings/",

  /** Billing Configuration */
  billingConfigurations = "/billing-configurations/",
  billingSchedules = "/billing-schedules/",
  paymentMethods = "/payment-methods/",
  billingConfigurationPaymentCredentials = "/billing-configuration-payment-credentials/",

  /** Intgerations */
  integrationProviders = "/integration-providers/",
  integrationConnections = "/integration-connections/",
  integrationCredentialStores = "/integration-credential-stores/",
  decryptCredentials = "/decrypt-credentials/",

  /** AI Workers*/
  aiTaskInstructions = "/ai-task-instructions/",

  /** Numbering sequences */
  numberingSequences = "/numbering-sequences/",

  /** Datasets */
  datasetReferences = "/dataset-references/",
  dataBanks = "/data-banks/",
  datasetSchemas = "/dataset-schemas/",
  datasetSchemaImport = "/dataset-schema/import/",
  datasetSchemaExport = "/dataset-schema/export/",
  datasetEntries = "/dataset-entries/",
  remoteDatasets = "/remote-datasets/",

  /** Memento - Undo and Recycle Bin */
  recycleBin = "/recycle-bin/",
  restoreVersion = "/reversion/restore-version/",

  /** Subscription Service */
  subscriptionPlansList = "/product-plans/",
  subscriptionCreateCheckoutSession = "/create-subscription-checkout-session/",
  subscriptionCreateOrganizationSubscription = "/create-organization-subscription/",
  subscriptionCreatePortalSession = "/create-portal-session/",
  getOrganizationSubscription = "/organization-subscription/",
  setupCreateCheckoutSession = "/create-setup-checkout-session/",
  subscriptionTrackers = "/subscription-trackers/",

  /** Media Libraries */
  mediaLibraries = "/media-library/",

  /** Translation */
  translationLocales = "/translation/locales/",
  manageTranslations = "/translation/manage/",
  translatableModels = "/translation/translatable-models/",
  translatableModelsPOFile = "/translation/translatable-models/po-file/",
}
